import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShowcaseService {
  showcaseList: AngularFireList<any>;

  constructor(private firebase: AngularFireDatabase) {
    this.showcaseList = this.firebase.list('showcase');
  }

  getShowcaseList(): Observable<any[]> {
    return this.showcaseList.snapshotChanges();
  }
}
